import dynamic from 'next/dynamic';
import { useRouter } from 'next/router';
import { getServerSideProps as getHomeServerSideProps } from 'pages';
import { useEffect } from 'react';

import HomePage from 'components/pages/Home';

import useModal from 'hooks/useModal';

import { stripQs } from 'lib/request';

import LINKS from 'constants/links';

const WishlistModal = dynamic(
  () => import('components/Wishlist/WishlistModal'),
  { ssr: false }
);

const WishlistPage = ({
  cardsAds,
  cookieIsUserLogged,
  recoveryPassword,
  serverFeaturedOffers,
  serverOffers,
  sidebarAd,
  smallAds,
}) => {
  const router = useRouter();
  const { showModal } = useModal();

  useEffect(() => {
    if (stripQs(router.asPath) === LINKS.WISHLIST) {
      showModal(WishlistModal);
    }
  }, [router.asPath]);

  return (
    <HomePage
      cardsAds={cardsAds}
      cookieIsUserLogged={cookieIsUserLogged}
      recoveryPassword={recoveryPassword}
      serverFeaturedOffers={serverFeaturedOffers}
      serverOffers={serverOffers}
      sidebarAd={sidebarAd}
      smallAds={smallAds}
    />
  );
};

export const getServerSideProps = getHomeServerSideProps;

export default WishlistPage;
